let api = null;
let loading = null;

export const loadFaceModels = async () => {
  if (api) return api;
  if (!loading) {
    loading = (async () => {
      const faceapi = await import("@vladmandic/face-api");
      await faceapi.tf.ready();
      await Promise.all([
        faceapi.nets.ssdMobilenetv1.loadFromUri("/models"),
        faceapi.nets.faceLandmark68Net.loadFromUri("/models"),
        faceapi.nets.faceRecognitionNet.loadFromUri("/models"),
      ]);
      api = faceapi;
      return faceapi;
    })().catch((e) => { loading = null; throw e; });
  }
  return loading;
};

export const faceDescriptor = async (input) => {
  const faceapi = await loadFaceModels();
  const res = await faceapi
    .detectSingleFace(input, new faceapi.SsdMobilenetv1Options({ minConfidence: 0.5 }))
    .withFaceLandmarks()
    .withFaceDescriptor();
  return res ? Array.from(res.descriptor) : null;
};

export const snapshot = (source, max = 320) => {
  const w = source.videoWidth || source.naturalWidth || source.width;
  const h = source.videoHeight || source.naturalHeight || source.height;
  const s = Math.min(1, max / Math.max(w, h));
  const c = document.createElement("canvas");
  c.width = Math.round(w * s); c.height = Math.round(h * s);
  c.getContext("2d").drawImage(source, 0, 0, c.width, c.height);
  return c.toDataURL("image/jpeg", 0.75);
};

export const blobToImage = (blob) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = () => reject(new Error("Could not read the photo"));
  img.src = URL.createObjectURL(blob);
});

export const getLocation = () => new Promise((resolve) => {
  if (!navigator.geolocation) { resolve({}); return; }
  navigator.geolocation.getCurrentPosition(
    (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: Math.round(p.coords.accuracy) }),
    () => resolve({}),
    { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 },
  );
});

export const mapLink = (x) => (x && x.lat != null ? `https://www.google.com/maps?q=${x.lat},${x.lng}` : "");
